var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_PRODUCTS = 'api/product';
const GET_SET_PRODUCTS_STORES = 'api/stores';
const GET_SET_PRODUCTS_SUPPLY = 'api/product-supply';
export const deleteById = function (id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.delete(`${GET_SET_PRODUCTS}/${id}`, config);
        }
        catch (error) {
            console.error('Error fetching deleteById:', error);
            throw error;
        }
    });
};
export const deleteProductSupplyById = function (...args) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const url = args.length === 3
                ? `${GET_SET_PRODUCTS_STORES}/${args[0]}/products/${args[1]}/supplies/${args[2]}`
                : `${GET_SET_PRODUCTS_SUPPLY}/${args[0]}/${args[1]}`;
            return yield this.axiosInstance.delete(url, config);
        }
        catch (error) {
            console.error('Error fetching deleteProductSupplyById:', error);
            throw error;
        }
    });
};
// New: delete (inactivate) product price option
export const deletePriceOption = function (productId, optionId) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            const response = yield this.axiosInstance.delete(`${GET_SET_PRODUCTS}/${productId}/price-options/${optionId}`, config);
            return response.data || {};
        }
        catch (error) {
            console.error('Error deleting price option:', error);
            throw error;
        }
    });
};
